import {
    Button,
    FormControl,
    FormLabel,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import Avatar from "components/MainApp/Profile/Avatar";
import { useAuth } from "hooks/auth";
import { useUpdateAvatar } from "hooks/users";

export default function EditProfile({ isOpen, onClose }) {
    const { user, isLoading: authLoading } = useAuth()
    const { setFile, updateAvatar, isLoading: fileLoading, fileURL } = useUpdateAvatar(user?.id)
    if (authLoading) return "Loading..."

    function handleChange(e) {
        setFile(e.target.files[0])
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent backgroundColor='#1a1a1d' color="#fff">
                <ModalHeader>Edit profile</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <HStack spacing="5">
                        <Avatar user={user} overrideAvatar={fileURL}/>
                        <FormControl py="4">
                            <FormLabel htmlFor="picture">Change avatar</FormLabel>
                            <input className="upload-input" type="file" accept="image/*" onChange={handleChange} />
                        </FormControl>
                    </HStack>
                    <Button
                        loadingText="Uploading"
                        w="full"
                        my="6"
                        colorScheme="teal"
                        onClick={updateAvatar}
                        isLoading={fileLoading}
                    >
                        Save
                    </Button>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}